export default function Button({ children, variant = 'primary', onClick, type = 'button' }) {
    const base = "px-4 py-2 font-medium transition w-max";
    const variants = {
      primary: "bg-indigo-600 rounded-md text-white hover:bg-indigo-700",
      secondary: "bg-gray-200 rounded-md text-gray-900 hover:bg-gray-300",
      danger: "bg-red-600 rounded-md text-white hover:bg-red-700",
      contact: "bg-indigo-600 rounded-full text-white hover:bg-indigo-700 h-[60px]",
      buy1:"bg-indigo-600 rounded-md text-white hover:bg-indigo-700 w-full",
      buy2:"bg-white rounded-md text-indigo-600 w-full"
    };
  
    return (
      <button type={type} onClick={onClick} className={`${base} ${variants[variant]}`}>
        {children}
      </button>
    )
  }
  